/**
 * Centralized environment configuration
 * Uses Vite's built-in environment variable system with proper fallbacks
 */

interface Config {
  AUTH_API_BASE_URL: string;
  CUSTOMER_API_BASE_URL: string;
  S3_BUCKET_NAME: string;
  S3_REGION: string;
}

const config: Config = {
  AUTH_API_BASE_URL: import.meta.env.VITE_AUTH_API_BASE_URL || 'http://localhost:3000',
  CUSTOMER_API_BASE_URL: import.meta.env.VITE_CUSTOMER_API_BASE_URL || 'http://localhost:3001',
  S3_BUCKET_NAME: import.meta.env.VITE_S3_BUCKET_NAME || 'ar-trial',
  S3_REGION: import.meta.env.VITE_S3_REGION || 'us-west-1',
} as const;

// Validation to ensure required environment variables are set
const validateConfig = (): void => {
  const requiredVars = ['VITE_AUTH_API_BASE_URL', 'VITE_CUSTOMER_API_BASE_URL'];
  const missing = requiredVars.filter(varName => !import.meta.env[varName]);
  
  if (missing.length > 0) {
    console.warn(`Missing environment variables: ${missing.join(', ')}`);
    console.warn('Using fallback values for development');
  }
};

// Run validation
validateConfig();

// Named exports for direct usage
export const { AUTH_API_BASE_URL, CUSTOMER_API_BASE_URL, S3_BUCKET_NAME, S3_REGION } = config;

// Default export for the entire config object
export default config;